var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNavSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 36 30",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27 9a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm9 7a9 9 0 1 0-18 0 9 9 0 0 0 18 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m21 22-7 7 7-7Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m13.293 28.293 7-7 1.414 1.414-7 7-1.414-1.414ZM32 2H0V0h32v2ZM12.844 16c0-.683.078-1.351.228-2H0v2h12.844ZM14.719 9c.481-.722.681-1.2 1.481-2H0v2h14.719Z"
})));
export default SvgNavSearch;